import { Player } from '../entities/Player';
import { Cat } from '../entities/Cat';
import { CatState } from '../types';

const COLLISION_DISTANCE = 0.7;

export function checkPlayerCatCollision(
  player: Player,
  cat: Cat,
  tileSize: number
): 'caught' | 'pounce' | null {
  if (cat.state === CatState.InHouse || cat.state === CatState.Exiting || cat.state === CatState.Fleeing) {
    return null;
  }

  const dx = Math.abs(player.pos.x - cat.pos.x);
  const dy = Math.abs(player.pos.y - cat.pos.y);
  const dist = Math.sqrt(dx * dx + dy * dy);

  if (dist < tileSize * COLLISION_DISTANCE) {
    if (cat.state === CatState.Scared) {
      return 'pounce';
    }
    return 'caught';
  }
  return null;
}
